export var LogLevel;
(function (LogLevel) {
    LogLevel["EMERGENCY"] = "emergency";
    LogLevel["ALERT"] = "alert";
    LogLevel["CRITICAL"] = "critical";
    LogLevel["ERROR"] = "error";
    LogLevel["WARNING"] = "warning";
    LogLevel["NOTICE"] = "notice";
    LogLevel["INFO"] = "info";
    LogLevel["DEBUG"] = "debug";
})(LogLevel || (LogLevel = {}));
//# sourceMappingURL=LoggerInterface.js.map